import React from "react";
import { useEffect, useState } from "react";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import MembGameRelLstApi from "Apis/MembGameRelLstApi";
import "Assets/css/MembGameRelLst.css";

const MembGameLvdSvcMnyLpopUi = () => {
       const langData:any = useOutletContext();
       const [membGameRelLstState,setMembGameRelLstState] = useState([]);
       var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
       var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
       const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }
       useEffect(()=>{
           MembGameRelLstApi().then((resp)=>(
               setMembGameRelLstState(resp.yrelLst)
           ));

       },[])
    return(
        <>
        <div className="membGameSvcRelLstWrap">
            <div className="membGameSvcMnyLpopTitlWrap">
                <h1>{langData&&langData.MYPAGE_MEMB_LVD_MNY_TITL_00}</h1>
                <p>{langData&&langData.MYPAGE_MEMB_LVD_MNY_DESC_00}</p>
            </div>
            <div className="membGameSvcRelCardWrap membGameSvcRelCardLpopWrap">
                <ul>
                    {membGameRelLstState&&membGameRelLstState.map((key:any) =>(
                        <li className="membGameSvcRelCard">
                            <div className="gameSvcThmbImgWrap">
                                <img src={key.thmbUrl} alt="" />
                            </div>
                            <div className="membGameSvcRelCardTextWrap">
                                <div className="gameSvcTitl">
                                    <h1>{key.gameNm}</h1>
                                </div>
                                <div className="membGameSvcTotMnyWrap">
                                    <p>{langData&&langData.MYPAGE_MAIN_GAME_MNY_LBL_00}</p>
                                    <p className="totMnyText">{key.totMny}</p>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
        
        </>
    )
}

export default MembGameLvdSvcMnyLpopUi;